export const countries = [{
    country: 'US',
    code: '+1',
    name: 'United States',
  },
  {
    country: 'CU',
    code: '+53',
    name: 'Cuba',
  },
  {
    name: 'Afghanistan',
    code: '+93',
    country: 'AF',
  }, {
    name: 'Aland Islands',
    code: '+358',
    country: 'AX',
  }, {
    name: 'Albania',
    code: '+355',
    country: 'AL',
  }, {
    name: 'Algeria',
    code: '+213',
    country: 'DZ',
  }, {
    name: 'AmericanSamoa',
    code: '+1 684',
    country: 'AS',
  }, {
    name: 'Andorra',
    code: '+376',
    country: 'AD',
  }, 
  {
    name: 'Angola',
    code: '+244',
    country: 'AO',
  },
   {
    name: 'Anguilla',
    code: '+1 264',
    country: 'AI',
  }, {
    name: 'Antarctica',
    code: '+672',
    country: 'AQ',
  },
   {
    name: 'Antigua and Barbuda',
    code: '+1268',
    country: 'AG',
  }, {
    name: 'Argentina',
    code: '+54',
    country: 'AR',
  },
   {
    name: 'Armenia',
    code: '+374',
    country: 'AM',
  }, {
    name: 'Aruba',
    code: '+297',
    country: 'AW',
  }, 
  {
    name: 'Australia',
    code: '+61',
    country: 'AU',
  }, {
    name: 'Austria',
    code: '+43',
    country: 'AT',
  }, {
    name: 'Azerbaijan',
    code: '+994',
    country: 'AZ',
  }, {
    name: 'Bahamas',
    code: '+1 242',
    country: 'BS',
  }, {
    name: 'Bahrain',
    code: '+973',
    country: 'BH',
  }, {
    name: 'Bangladesh',
    code: '+880',
    country: 'BD',
  }, {
    name: 'Barbados',
    code: '+1 246',
    country: 'BB',
  }, {
    name: 'Belarus',
    code: '+375',
    country: 'BY',
  }, {
    name: 'Belgium',
    code: '+32',
    country: 'BE',
  }, {
    name: 'Belize',
    code: '+501',
    country: 'BZ',
  }, {
    name: 'Benin',
    code: '+229',
    country: 'BJ',
  }, {
    name: 'Bermuda',
    code: '+1 441',
    country: 'BM',
  }, {
    name: 'Bhutan',
    code: '+975',
    country: 'BT',
  }, {
    name: 'Bolivia, Plurinational State of',
    code: '+591',
    country: 'BO',
  }, {
    name: 'Bosnia and Herzegovina',
    code: '+387',
    country: 'BA',
  }, {
    name: 'Botswana',
    code: '+267',
    country: 'BW',
  }, {
    name: 'Brazil',
    code: '+55',
    country: 'BR',
  }, {
    name: 'British Indian Ocean Territory',
    code: '+246',
    country: 'IO',
  }, {
    name: 'Brunei Darussalam',
    code: '+673',
    country: 'BN',
  },
   {
    name: 'Bulgaria',
    code: '+359',
    country: 'BG',
  }, {
    name: 'Burkina Faso',
    code: '+226',
    country: 'BF',
  }, {
    name: 'Burundi',
    code: '+257',
    country: 'BI',
  }, {
    name: 'Cambodia',
    code: '+855',
    country: 'KH',
  }, {
    name: 'Cameroon',
    code: '+237',
    country: 'CM',
  }, 
  {
    name: 'Canada',
    code: '+1',
    country: 'CA',
  }, 
  {
    name: 'Cape Verde',
    code: '+238',
    country: 'CV',
  }, {
    name: 'Cayman Islands',
    code: '+ 345',
    country: 'KY',
  }, {
    name: 'Central African Republic',
    code: '+236',
    country: 'CF',
  }, {
    name: 'Chad',
    code: '+235',
    country: 'TD',
  }, 
  {
    name: 'Chile',
    code: '+56',
    country: 'CL',
  }, {
    name: 'China',
    code: '+86',
    country: 'CN',
  }, 
  {
    name: 'Christmas Island',
    code: '+61',
    country: 'CX',
  }, {
    name: 'Cocos (Keeling) Islands',
    code: '+61',
    country: 'CC',
  },
   {
    name: 'Colombia',
    code: '+57',
    country: 'CO',
  },
   {
    name: 'Comoros',
    code: '+269',
    country: 'KM',
  }, {
    name: 'Congo',
    code: '+242',
    country: 'CG',
  }, {
    name: 'Congo, The Democratic Republic of the Congo',
    code: '+243',
    country: 'CD',
  }, {
    name: 'Cook Islands',
    code: '+682',
    country: 'CK',
  },
   {
    name: 'Costa Rica',
    code: '+506',
    country: 'CR',
  }, 
  {
    name: "Cote d'Ivoire",
    code: '+225',
    country: 'CI',
  }, {
    name: 'Croatia',
    code: '+385',
    country: 'HR',
  }, {
    name: 'Cyprus',
    code: '+357',
    country: 'CY',
  }, {
    name: 'Czech Republic',
    code: '+420',
    country: 'CZ',
  }, {
    name: 'Denmark',
    code: '+45',
    country: 'DK',
  }, {
    name: 'Djibouti',
    code: '+253',
    country: 'DJ',
  },
   {
    name: 'Dominica',
    code: '+1 767',
    country: 'DM',
  }, {
    name: 'Dominican Republic',
    code: '+1 849',
    country: 'DO',
  }, {
    name: 'Ecuador',
    code: '+593',
    country: 'EC',
  }, {
    name: 'Egypt',
    code: '+20',
    country: 'EG',
  }, {
    name: 'El Salvador',
    code: '+503',
    country: 'SV',
  }, {
    name: 'Equatorial Guinea',
    code: '+240',
    country: 'GQ',
  },
   {
    name: 'Eritrea',
    code: '+291',
    country: 'ER',
  }, {
    name: 'Estonia',
    code: '+372',
    country: 'EE',
  }, {
    name: 'Ethiopia',
    code: '+251',
    country: 'ET',
  }, {
    name: 'Falkland Islands (Malvinas)',
    code: '+500',
    country: 'FK',
  }, {
    name: 'Faroe Islands',
    code: '+298',
    country: 'FO',
  }, {
    name: 'Fiji',
    code: '+679',
    country: 'FJ',
  }, {
    name: 'Finland',
    code: '+358',
    country: 'FI',
  }, 
  {
    name: 'France',
    code: '+33',
    country: 'FR',
  }, {
    name: 'French Guiana',
    code: '+594',
    country: 'GF',
  }, {
    name: 'French Polynesia',
    code: '+689',
    country: 'PF',
  },
   {
    name: 'Gabon',
    code: '+241',
    country: 'GA',
  }, {
    name: 'Gambia',
    code: '+220',
    country: 'GM',
  }, {
    name: 'Georgia',
    code: '+995',
    country: 'GE',
  }, {
    name: 'Germany',
    code: '+49',
    country: 'DE',
  }, {
    name: 'Ghana',
    code: '+233',
    country: 'GH',
  }, {
    name: 'Gibraltar',
    code: '+350',
    country: 'GI',
  }, {
    name: 'Greece',
    code: '+30',
    country: 'GR',
  }, {
    name: 'Greenland',
    code: '+299',
    country: 'GL',
  }, {
    name: 'Grenada',
    code: '+1 473',
    country: 'GD',
  }, 
  {
    name: 'Guadeloupe',
    code: '+590',
    country: 'GP',
  }, {
    name: 'Guam',
    code: '+1 671',
    country: 'GU',
  }, {
    name: 'Guatemala',
    code: '+502',
    country: 'GT',
  }, {
    name: 'Guernsey',
    code: '+44',
    country: 'GG',
  }, {
    name: 'Guinea',
    code: '+224',
    country: 'GN',
  }, {
    name: 'Guinea-Bissau',
    code: '+245',
    country: 'GW',
  }, {
    name: 'Guyana',
    code: '+595',
    country: 'GY',
  }, {
    name: 'Haiti',
    code: '+509',
    country: 'HT',
  }, {
    name: 'Holy See (Vatican City State)',
    code: '+379',
    country: 'VA',
  }, {
    name: 'Honduras',
    code: '+504',
    country: 'HN',
  }, {
    name: 'Hong Kong',
    code: '+852',
    country: 'HK',
  }, {
    name: 'Hungary',
    code: '+36',
    country: 'HU',
  }, {
    name: 'Iceland',
    code: '+354',
    country: 'IS',
  }, {
    name: 'India',
    code: '+91',
    country: 'IN',
  }, {
    name: 'Indonesia',
    code: '+62',
    country: 'ID',
  }, {
    name: 'Iran, Islamic Republic of Persian Gulf',
    code: '+98',
    country: 'IR',
  }, {
    name: 'Iraq',
    code: '+964',
    country: 'IQ',
  }, {
    name: 'Ireland',
    code: '+353',
    country: 'IE',
  }, {
    name: 'Isle of Man',
    code: '+44',
    country: 'IM',
  }, {
    name: 'Israel',
    code: '+972',
    country: 'IL',
  }, {
    name: 'Italy',
    code: '+39',
    country: 'IT',
  }, {
    name: 'Jamaica',
    code: '+1 876',
    country: 'JM',
  }, {
    name: 'Japan',
    code: '+81',
    country: 'JP',
  }, {
    name: 'Jersey',
    code: '+44',
    country: 'JE',
  }, {
    name: 'Jordan',
    code: '+962',
    country: 'JO',
  }, {
    name: 'Kazakhstan',
    code: '+7 7',
    country: 'KZ',
  }, {
    name: 'Kenya',
    code: '+254',
    country: 'KE',
  }, {
    name: 'Kiribati',
    code: '+686',
    country: 'KI',
  }, {
    name: "Korea, Democratic People's Republic of Korea",
    code: '+850',
    country: 'KP',
  }, {
    name: 'Korea, Republic of South Korea',
    code: '+82',
    country: 'KR',
  }, {
    name: 'Kuwait',
    code: '+965',
    country: 'KW',
  }, {
    name: 'Kyrgyzstan',
    code: '+996',
    country: 'KG',
  }, {
    name: 'Laos',
    code: '+856',
    country: 'LA',
  }, {
    name: 'Latvia',
    code: '+371',
    country: 'LV',
  }, {
    name: 'Lebanon',
    code: '+961',
    country: 'LB',
  }, {
    name: 'Lesotho',
    code: '+266',
    country: 'LS',
  }, {
    name: 'Liberia',
    code: '+231',
    country: 'LR',
  }, {
    name: 'Libyan Arab Jamahiriya',
    code: '+218',
    country: 'LY',
  }, {
    name: 'Liechtenstein',
    code: '+423',
    country: 'LI',
  }, {
    name: 'Lithuania',
    code: '+370',
    country: 'LT',
  }, {
    name: 'Luxembourg',
    code: '+352',
    country: 'LU',
  }, {
    name: 'Macao',
    code: '+853',
    country: 'MO',
  }, {
    name: 'Macedonia',
    code: '+389',
    country: 'MK',
  }, {
    name: 'Madagascar',
    code: '+261',
    country: 'MG',
  }, {
    name: 'Malawi',
    code: '+265',
    country: 'MW',
  }, {
    name: 'Malaysia',
    code: '+60',
    country: 'MY',
  }, {
    name: 'Maldives',
    code: '+960',
    country: 'MV',
  }, {
    name: 'Mali',
    code: '+223',
    country: 'ML',
  }, {
    name: 'Malta',
    code: '+356',
    country: 'MT',
  }, {
    name: 'Marshall Islands',
    code: '+692',
    country: 'MH',
  }, {
    name: 'Martinique',
    code: '+596',
    country: 'MQ',
  }, {
    name: 'Mauritania',
    code: '+222',
    country: 'MR',
  }, {
    name: 'Mauritius',
    code: '+230',
    country: 'MU',
  }, {
    name: 'Mayotte',
    code: '+262',
    country: 'YT',
  }, {
    name: 'Mexico',
    code: '+52',
    country: 'MX',
  }, {
    name: 'Micronesia, Federated States of Micronesia',
    code: '+691',
    country: 'FM',
  }, {
    name: 'Moldova',
    code: '+373',
    country: 'MD',
  }, {
    name: 'Monaco',
    code: '+377',
    country: 'MC',
  }, {
    name: 'Mongolia',
    code: '+976',
    country: 'MN',
  }, {
    name: 'Montenegro',
    code: '+382',
    country: 'ME',
  }, {
    name: 'Montserrat',
    code: '+1664',
    country: 'MS',
  }, {
    name: 'Morocco',
    code: '+212',
    country: 'MA',
  }, {
    name: 'Mozambique',
    code: '+258',
    country: 'MZ',
  }, {
    name: 'Myanmar',
    code: '+95',
    country: 'MM',
  }, {
    name: 'Namibia',
    code: '+264',
    country: 'NA',
  }, {
    name: 'Nauru',
    code: '+674',
    country: 'NR',
  }, {
    name: 'Nepal',
    code: '+977',
    country: 'NP',
  }, {
    name: 'Netherlands',
    code: '+31',
    country: 'NL',
  }, {
    name: 'Netherlands Antilles',
    code: '+599',
    country: 'AN',
  }, {
    name: 'New Caledonia',
    code: '+687',
    country: 'NC',
  }, {
    name: 'New Zealand',
    code: '+64',
    country: 'NZ',
  }, {
    name: 'Nicaragua',
    code: '+505',
    country: 'NI',
  }, {
    name: 'Niger',
    code: '+227',
    country: 'NE',
  }, {
    name: 'Nigeria',
    code: '+234',
    country: 'NG',
  }, {
    name: 'Niue',
    code: '+683',
    country: 'NU',
  }, {
    name: 'Norfolk Island',
    code: '+672',
    country: 'NF',
  }, {
    name: 'Northern Mariana Islands',
    code: '+1 670',
    country: 'MP',
  }, {
    name: 'Norway',
    code: '+47',
    country: 'NO',
  }, {
    name: 'Oman',
    code: '+968',
    country: 'OM',
  }, {
    name: 'Pakistan',
    code: '+92',
    country: 'PK',
  }, {
    name: 'Palau',
    code: '+680',
    country: 'PW',
  }, {
    name: 'Palestinian Territory, Occupied',
    code: '+970',
    country: 'PS',
  }, {
    name: 'Panama',
    code: '+507',
    country: 'PA',
  }, {
    name: 'Papua New Guinea',
    code: '+675',
    country: 'PG',
  }, {
    name: 'Paraguay',
    code: '+595',
    country: 'PY',
  }, {
    name: 'Peru',
    code: '+51',
    country: 'PE',
  }, {
    name: 'Philippines',
    code: '+63',
    country: 'PH',
  }, {
    name: 'Pitcairn',
    code: '+872',
    country: 'PN',
  }, {
    name: 'Poland',
    code: '+48',
    country: 'PL',
  }, {
    name: 'Portugal',
    code: '+351',
    country: 'PT',
  }, {
    name: 'Puerto Rico',
    code: '+1 939',
    country: 'PR',
  }, {
    name: 'Qatar',
    code: '+974',
    country: 'QA',
  }, {
    name: 'Romania',
    code: '+40',
    country: 'RO',
  }, {
    name: 'Russia',
    code: '+7',
    country: 'RU',
  }, {
    name: 'Rwanda',
    code: '+250',
    country: 'RW',
  }, {
    name: 'Reunion',
    code: '+262',
    country: 'RE',
  }, {
    name: 'Saint Barthelemy',
    code: '+590',
    country: 'BL',
  }, {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    code: '+290',
    country: 'SH',
  }, {
    name: 'Saint Kitts and Nevis',
    code: '+1 869',
    country: 'KN',
  }, {
    name: 'Saint Lucia',
    code: '+1 758',
    country: 'LC',
  }, {
    name: 'Saint Martin',
    code: '+590',
    country: 'MF',
  }, {
    name: 'Saint Pierre and Miquelon',
    code: '+508',
    country: 'PM',
  }, {
    name: 'Saint Vincent and the Grenadines',
    code: '+1 784',
    country: 'VC',
  }, {
    name: 'Samoa',
    code: '+685',
    country: 'WS',
  }, {
    name: 'San Marino',
    code: '+378',
    country: 'SM',
  }, {
    name: 'Sao Tome and Principe',
    code: '+239',
    country: 'ST',
  }, {
    name: 'Saudi Arabia',
    code: '+966',
    country: 'SA',
  }, {
    name: 'Senegal',
    code: '+221',
    country: 'SN',
  }, {
    name: 'Serbia',
    code: '+381',
    country: 'RS',
  }, {
    name: 'Seychelles',
    code: '+248',
    country: 'SC',
  }, {
    name: 'Sierra Leone',
    code: '+232',
    country: 'SL',
  }, {
    name: 'Singapore',
    code: '+65',
    country: 'SG',
  }, {
    name: 'Slovakia',
    code: '+421',
    country: 'SK',
  }, {
    name: 'Slovenia',
    code: '+386',
    country: 'SI',
  }, {
    name: 'Solomon Islands',
    code: '+677',
    country: 'SB',
  }, {
    name: 'Somalia',
    code: '+252',
    country: 'SO',
  }, {
    name: 'South Africa',
    code: '+27',
    country: 'ZA',
  }, {
    name: 'South Georgia and the South Sandwich Islands',
    code: '+500',
    country: 'GS',
  }, {
    name: 'Spain',
    code: '+34',
    country: 'ES',
  }, {
    name: 'Sri Lanka',
    code: '+94',
    country: 'LK',
  }, {
    name: 'Sudan',
    code: '+249',
    country: 'SD',
  }, {
    name: 'Suriname',
    code: '+597',
    country: 'SR',
  }, {
    name: 'Svalbard and Jan Mayen',
    code: '+47',
    country: 'SJ',
  }, {
    name: 'Swaziland',
    code: '+268',
    country: 'SZ',
  }, {
    name: 'Sweden',
    code: '+46',
    country: 'SE',
  }, {
    name: 'Switzerland',
    code: '+41',
    country: 'CH',
  }, {
    name: 'Syrian Arab Republic',
    code: '+963',
    country: 'SY',
  }, {
    name: 'Taiwan',
    code: '+886',
    country: 'TW',
  }, {
    name: 'Tajikistan',
    code: '+992',
    country: 'TJ',
  }, {
    name: 'Tanzania, United Republic of Tanzania',
    code: '+255',
    country: 'TZ',
  }, {
    name: 'Thailand',
    code: '+66',
    country: 'TH',
  }, {
    name: 'Timor-Leste',
    code: '+670',
    country: 'TL',
  }, {
    name: 'Togo',
    code: '+228',
    country: 'TG',
  }, {
    name: 'Tokelau',
    code: '+690',
    country: 'TK',
  }, {
    name: 'Tonga',
    code: '+676',
    country: 'TO',
  }, {
    name: 'Trinidad and Tobago',
    code: '+1 868',
    country: 'TT',
  }, {
    name: 'Tunisia',
    code: '+216',
    country: 'TN',
  }, {
    name: 'Turkey',
    code: '+90',
    country: 'TR',
  }, {
    name: 'Turkmenistan',
    code: '+993',
    country: 'TM',
  }, {
    name: 'Turks and Caicos Islands',
    code: '+1 649',
    country: 'TC',
  }, {
    name: 'Tuvalu',
    code: '+688',
    country: 'TV',
  }, {
    name: 'Uganda',
    code: '+256',
    country: 'UG',
  }, {
    name: 'Ukraine',
    code: '+380',
    country: 'UA',
  }, {
    name: 'United Arab Emirates',
    code: '+971',
    country: 'AE',
  }, {
    name: 'United Kingdom',
    code: '+44',
    country: 'GB',
  },
  
  {
    name: 'Uruguay',
    code: '+598',
    country: 'UY',
  }, {
    name: 'Uzbekistan',
    code: '+998',
    country: 'UZ',
  }, {
    name: 'Vanuatu',
    code: '+678',
    country: 'VU',
  }, {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    code: '+58',
    country: 'VE',
  }, {
    name: 'Vietnam',
    code: '+84',
    country: 'VN',
  }, {
    name: 'Virgin Islands, British',
    code: '+1 284',
    country: 'VG',
  }, {
    name: 'Virgin Islands, U.S.',
    code: '+1 340',
    country: 'VI',
  }, {
    name: 'Wallis and Futuna',
    code: '+681',
    country: 'WF',
  }, {
    name: 'Yemen',
    code: '+967',
    country: 'YE',
  }, {
    name: 'Zambia',
    code: '+260',
    country: 'ZM',
  }, {
    name: 'Zimbabwe',
    code: '+263',
    country: 'ZW',
  },
  ];
  